import PropTypes from 'prop-types';
import PropsType from 'props-type';

import icon from '@app/assets/icons/icon-warning.svg';

const propTypes = {
  cancelButton: PropTypes.element.isRequired,
  children: PropTypes.node.isRequired,
  closeButton: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
};

type WarningModalProps = PropsType<typeof propTypes>;

function WarningModal({ cancelButton, children, closeButton, title }: WarningModalProps) {
  return (
    <div className="Container Container--xs">
      <div className="Card Card--pop box-7x align-center">
        <img alt="" src={icon} />
        <h3 className="space-4x">
          <strong>{title}</strong>
        </h3>
        <p className="space-4x">{children}</p>
        {cancelButton}
        {closeButton}
      </div>
    </div>
  );
}

WarningModal.propTypes = propTypes;

export default WarningModal;
